import {
  FileText,
  Calendar,
  Settings,
  UserCheck,
  Sparkles,
  FileStack,
  Kanban,
  LayoutDashboard,
  FileCheck,
  Info,
  UserPlus,
  BarChart3,
} from 'lucide-react';
import { NavigationGroup } from '@/types/navigation';
import { MENU_PERMISSION_MAP } from '@/lib/permission-access';

export { MENU_PERMISSION_MAP };

// 定义菜单组
export const menuGroups: NavigationGroup[] = [
  {
    id: 'main-menu',
    label: '主菜单',
    items: [
      {
        id: 'dashboard',
        label: '仪表盘',
        icon: BarChart3,
        path: '/dashboard',
        disabled: false,
      },
      {
        id: 'workbench',
        label: '工作台',
        icon: LayoutDashboard,
        path: '/workbench',
        disabled: false,
      },
      {
        id: 'internal-referral',
        label: '内推渠道',
        icon: UserPlus,
        path: '/internal-referral',
        disabled: false,
      },
      {
        id: 'recruitment-pipeline',
        label: '招聘流程',
        icon: Kanban,
        path: '/recruitment-pipeline',
        disabled: false,
      },
      {
        id: 'job-profile',
        label: '职位管理',
        icon: UserCheck,
        path: '/job-profile',
        disabled: false,
      },
      {
        id: 'resume-management',
        label: '简历管理',
        icon: FileText,
        path: '/resume-management',
        disabled: false,
      },
      {
        id: 'intelligent-matching',
        label: '智能匹配',
        icon: Sparkles,
        path: '/intelligent-matching',
        disabled: false,
      },
      {
        id: 'interview-schedule',
        label: '面试管理',
        icon: Calendar,
        path: '/interview-management',
        disabled: false,
      },
      {
        id: 'offer-management',
        label: 'Offer管理',
        icon: FileCheck,
        path: '/offer-management',
        disabled: false,
      },
    ],
  },
  {
    id: 'system-config',
    label: '系统配置',
    items: [
      {
        id: 'platform-basic-config',
        label: '基本信息',
        icon: Info,
        path: '/platform-basic-config',
        disabled: false,
      },
      {
        id: 'platform-config',
        label: '基础配置',
        icon: FileStack,
        path: '/platform-config',
        disabled: false,
      },
      {
        id: 'system-settings',
        label: '系统设置',
        icon: Settings,
        path: '/system-settings',
        disabled: false,
      },
      {
        id: 'operation-log',
        label: '操作日志',
        icon: FileText,
        path: '/operation-log',
        disabled: false,
      },
    ],
  },
];
